import { render, staticRenderFns } from "./RigheReintegroList.vue?vue&type=template&id=5c65e8c8&scoped=true"
import script from "./RigheReintegroList.vue?vue&type=script&lang=ts"
export * from "./RigheReintegroList.vue?vue&type=script&lang=ts"
import style0 from "./RigheReintegroList.vue?vue&type=style&index=0&id=5c65e8c8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c65e8c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c65e8c8')) {
      api.createRecord('5c65e8c8', component.options)
    } else {
      api.reload('5c65e8c8', component.options)
    }
    module.hot.accept("./RigheReintegroList.vue?vue&type=template&id=5c65e8c8&scoped=true", function () {
      api.rerender('5c65e8c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RigheReintegroList.vue"
export default component.exports